// @flow
import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import CategoryItem from 'components/categories/CategoryItem';
import CategoryNavItem from 'components/categories/CategoryNavItem';
import CategorySubItem from 'components/categories/CategorySubItem';
import { type CategoryData } from 'store/modules/common';
import { escapeForUrl } from 'lib/common';
import './CategoryItemList.scss';

type Props = {
  // categories: 알파벳 분류, categories1: 알파벳 하위 분류(최종 상품 바로 위의 분류)
  categories: ?(CategoryData[]),
  categories1: ?(CategoryData[]),
  onSelectCategory: (info: any) => void,
};

const CategoryItemList = ({ categories, categories1, location }: Props) => {
  if (!categories) return null;
  const categoryList = categories.map(doc => (
    <div className="box-category" id={`${escapeForUrl(doc.name)}`} key={doc.id}>
      <CategoryItem key={doc.id} name={doc.name} />
      <div className="sub-category">
        {categories1
          .filter(docs => docs.parent === doc.id)
          .map((doc1, j) => (
            <CategorySubItem key={doc1.id} name={doc1.name} count={doc1.products_count} />
          ))}
      </div>
    </div>
  ));

  const categoryNav = categories.map(doc => {
    const lengthByCategory = categories1.filter(docs => docs.parent === doc.id).length;
    return lengthByCategory ? (
      <CategoryNavItem key={doc.id} name={doc.name} />
    ) : (
      <a className="CategoryNavItem empty" href="#" key={doc.id}>
        <div className="name">{doc.name}</div>
      </a>
    );
  });

  useEffect(() => {
    const { hash } = location;
    if (location.hash) {
      const nav = document.getElementById(hash[1]);

      window.scrollTo({ top: nav.offsetTop, behavior: 'smooth' });
    }
  });

  return (
    <div className="CategoryItemList">
      <div id="nav">{categoryNav}</div>
      {categoryList}
    </div>
  );
};

export default withRouter(CategoryItemList);



// WEBPACK FOOTER //
// ./src/components/categories/CategoryItemList/CategoryItemList.js